/**
 * `<media-lightbox>` custom element (roadmap v1.1, image zoom on the PDP).
 *
 * One native <dialog> per product page. A click on any `[data-media-zoom]`
 * button copies its `data-zoom-src` and the alt of the image inside it into
 * the dialog's <img> and opens it modally. Focus trap, Esc and focus return
 * are the dialog's own; a click on the backdrop closes it.
 */
class MediaLightbox extends HTMLElement {
  constructor() {
    super();
    this.dialog = this.querySelector('dialog');
    this.image = this.querySelector('[data-media-lightbox-image]');
  }

  connectedCallback() {
    if (!this.dialog) return;

    document.addEventListener('click', (event) => {
      const zoom = event.target.closest('[data-media-zoom]');
      if (zoom) {
        const thumb = zoom.querySelector('img');
        this.image.src = zoom.dataset.zoomSrc;
        this.image.alt = thumb ? thumb.alt : '';
        this.dialog.showModal();
        return;
      }
      if (event.target.closest('[data-media-lightbox-close]')) this.dialog.close();
    });

    this.dialog.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.dialog.close();
    });
  }
}

if (!customElements.get('media-lightbox')) {
  customElements.define('media-lightbox', MediaLightbox);
}
